import { forwardRef } from "react";
import {
  Checkbox as CheckboxPrimitive,
  type CheckboxProps as CheckboxPrimitiveProps,
} from "react-aria-components";
import { type PropsWithOptionalTestID } from "@boi/components-core";
import { TickIcon, MinusIcon } from "@boi/react-icons";

import * as S from "./CheckboxV2.styled";
import {
  InputLabelRightV2,
  type InputLabelRightV2Props,
} from "../InputLabelRightV2";

export type CheckboxV2Props = PropsWithOptionalTestID &
  Omit<CheckboxPrimitiveProps, "children"> & {
    labelProps?: Omit<InputLabelRightV2Props, "children">;
  };

const CheckboxV2 = forwardRef<HTMLLabelElement, CheckboxV2Props>(
  (props, ref) => {
    const { labelProps, testID = "checkbox", ...otherProps } = props;

    return (
      <CheckboxPrimitive {...otherProps} ref={ref} data-testid={testID}>
        {({ isSelected, isIndeterminate }) => (
          <InputLabelRightV2 {...labelProps}>
            <S.Container>
              {isSelected && !isIndeterminate && (
                <TickIcon data-testid={`${testID}-selected-icon`} />
              )}
              {isIndeterminate && (
                <MinusIcon data-testid={`${testID}-indeterminate-icon`} />
              )}
            </S.Container>
          </InputLabelRightV2>
        )}
      </CheckboxPrimitive>
    );
  }
);

CheckboxV2.displayName = "CheckboxV2";

export default CheckboxV2;
